/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()

/*==================================
TOYNG NEWSLETTER POPUP
==================================*/

document.addEventListener("DOMContentLoaded", function () {
    const popup = document.getElementById("toyng-popup");
    if (!popup) return;
    if (window.location.pathname.includes("/checkouts")) return;

    const popupBox = popup.querySelector(".toyng-popup");
    if (!popupBox) return;

    // Si el almacenamiento está bloqueado, el cupón sigue funcionando.
    function readStorage(key) {
        try {
            return localStorage.getItem(key);
        } catch (error) {
            return null;
        }
    }

    function saveStorage(key, value) {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            // No bloquear el cupón.
        }
    }

    // Pestaña fija para reabrir el cupón.
    const launcher = document.createElement("button");
    launcher.type = "button";
    launcher.id = "toyng-coupon-launcher";
    launcher.textContent = "🎁 Obtén 15% de descuento";
    launcher.setAttribute("aria-controls", "toyng-popup");
    launcher.setAttribute("aria-expanded", "false");
    launcher.style.cssText = [
        "position:fixed",
        "left:16px",
        "bottom:calc(16px + env(safe-area-inset-bottom, 0px))",
        "z-index:9990",
        "background:#ffffff",
        "color:#111111",
        "border:1px solid #dddddd",
        "border-radius:28px",
        "padding:14px 20px",
        "min-height:48px",
        "box-shadow:0 4px 18px rgba(0,0,0,.18)",
        "font:inherit",
        "font-weight:700",
        "cursor:pointer",
        "max-width:calc(100vw - 32px)"
    ].join(";");

    document.body.appendChild(launcher);

    let autoTimer;
    let closeTimer;
    let animationTimer;
    let previousFocus;

    function openPopup() {
        clearTimeout(autoTimer);
        clearTimeout(closeTimer);
        clearTimeout(animationTimer);

        previousFocus = document.activeElement;
        popup.style.display = "flex";
        launcher.hidden = true;
        launcher.setAttribute("aria-expanded", "true");

        saveStorage("toyngPopupShown", "true");

        animationTimer = setTimeout(function () {
            popupBox.classList.add("show");

            const closeButton = popup.querySelector(
                ".toyng-popup-close"
            );
            if (closeButton) closeButton.focus();
        }, 50);
    }

    function closePopup() {
        clearTimeout(autoTimer);
        clearTimeout(animationTimer);

        saveStorage("toyngPopupClosed", String(Date.now()));
        popupBox.classList.remove("show");
        launcher.setAttribute("aria-expanded", "false");

        closeTimer = setTimeout(function () {
            popup.style.display = "none";
            launcher.hidden = false;

            if (previousFocus && popup.contains(previousFocus)) {
                launcher.focus();
            } else if (
                previousFocus &&
                document.contains(previousFocus)
            ) {
                previousFocus.focus();
            }
        }, 250);
    }

    launcher.addEventListener("click", openPopup);

    const closeBtn = popup.querySelector(".toyng-popup-close");
    if (closeBtn) {
        closeBtn.addEventListener("click", function (event) {
            event.preventDefault();
            closePopup();
        });
    }

    const noThanks = popup.querySelector(".toyng-no-thanks");
    if (noThanks) {
        noThanks.addEventListener("click", function (event) {
            event.preventDefault();
            closePopup();
        });
    }

    popup.addEventListener("click", function (event) {
        if (event.target === popup) closePopup();
    });

    document.addEventListener("keydown", function (event) {
        if (
            event.key === "Escape" &&
            popupBox.classList.contains("show")
        ) {
            closePopup();
        }
    });

    // Apertura automática una sola vez por navegador.
    // La pestaña sigue disponible aunque ya se haya mostrado.
    const alreadyShown =
        readStorage("toyngPopupShown") === "true";
    const subscribed =
        readStorage("toyngNewsletterSubscribed") === "true";
    const previouslyClosed = Boolean(
        readStorage("toyngPopupClosed")
    );

    if (popup.querySelector(".toyng-success")) {
        openPopup();
    } else if (!alreadyShown && !subscribed && !previouslyClosed) {
        autoTimer = setTimeout(openPopup, 4500);
    }


    // Estado de envío del formulario.
    const newsletter = document.getElementById("toyng-newsletter");
    if (newsletter) {
        newsletter.addEventListener("submit", function () {
            const btn = document.getElementById("newsletter-submit");
            if (!btn) return;

            btn.disabled = true;
            btn.textContent = "⏳ Enviando...";
        });
    }

    // Comprar ahora.
    const continueBtn = document.getElementById("continue-shopping");
    if (continueBtn) {
        continueBtn.addEventListener("click", function (event) {
            event.preventDefault();
            closePopup();
        });
    }

    // Copiar cupón.
    const copyBtn = document.getElementById("copy-coupon");
    if (copyBtn) {
        copyBtn.addEventListener("click", async function (event) {
            event.preventDefault();

            try {
                await navigator.clipboard.writeText("BIENVENIDO15");
                copyBtn.textContent = "✅ ¡Cupón copiado!";
            } catch (error) {
                copyBtn.textContent = "Tu código: BIENVENIDO15";
            }

            setTimeout(function () {
                copyBtn.textContent = "📋 Copiar cupón";
            }, 2000);
        });
    }
});
